import { getApi } from '../api';

/**
 * DELETE /api/v2/accounts/{account}/shipments/{shipment}/routes/{routeId}
 */
export default async function deleteAccountShipmentRouteSegment(
  accountId: number,
  shipmentId: number,
  routeId: number,
): Promise<void> {
  const { api, baseURL } = getApi();
  try {
    await api.delete(
      `/api/v2/accounts/${accountId}/shipments/${shipmentId}/routes/${routeId}`,
      { baseURL },
    );
  } catch (err: unknown) {
    const status = (err as { response?: { status?: number } })?.response
      ?.status;
    if (status === 404) return;
    throw err;
  }
}
